import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { DataTypeProvider } from '@devexpress/dx-react-grid';
import { EMPTY_CELL_VALUE } from '../../../../NRReactGridCustomComponents/CellComponent/CellComponent';
import {
  getStatusBadgeStyles,
  getStatusBadgeVariantFromCategoryColor
} from '../../../../../pages/NRSettings/NRIntegrations/NRJiraIntegration/jiraStatusBadge.utils';

function NRJiraTicketStatusFormatter({ value, row }) {
  const theme = useTheme();

  if (value == null || value === '') {
    return EMPTY_CELL_VALUE;
  }

  const colors = getStatusBadgeStyles(theme, getStatusBadgeVariantFromCategoryColor(row?.statusCategoryColor));

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        px: theme.spacing(1),
        py: theme.spacing(0.5),
        borderRadius: theme.spacing(0.5),
        border: `1px solid ${colors.border}`,
        backgroundColor: colors.background,
        color: colors.color,
        maxWidth: '100%'
      }}
    >
      <Typography variant="body2" noWrap>
        {value}
      </Typography>
    </Box>
  );
}

export function NRJiraTicketStatusProvider(props) {
  return <DataTypeProvider formatterComponent={NRJiraTicketStatusFormatter} {...props} />;
}
